import * as React from "react";
const SvgList420Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM5 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM7.003 5.5H18v-2H7.003v2ZM18 11H7.003V9H18v2ZM7.003 16.5H18v-2H7.003v2Z"
    })
  );
export default SvgList420Px;
